import * as tPromise from "io-ts-promise";
import {
  AccountDimension,
  Co2Month,
  co2ResponseT,
  EntityAccount,
  entityAccountsT,
  GeoRow,
  geographyResponseT,
  InvoicingStats,
  invoicingStatsT,
  MonthlyTotal,
  monthlyTotalsT,
  NamedValue,
  OrderManualCost,
  OrderRow,
  orderRowsT,
  PeriodSummary,
  periodSummaryT,
  ProductMixRow,
  productMixRowsT,
  RuleCostLine,
  UtilizationRow,
  utilizationRowsT,
} from "dora-contracts";
import axios, { getData } from "../../axios";

export type {
  AccountDimension,
  Co2Month,
  EntityAccount,
  GeoRow,
  InvoicingStats,
  MonthlyTotal,
  NamedValue,
  OrderManualCost,
  OrderRow as InsightOrder,
  PeriodSummary,
  ProductMixRow,
  RuleCostLine,
  UtilizationRow,
};

export const getInsightsSummary = async (
  from: string,
  to: string
): Promise<PeriodSummary> =>
  axios
    .get("/api/insights/summary", { params: { from, to } })
    .then(getData)
    .then(tPromise.decode(periodSummaryT));

export const getInsightsOrders = async (
  from: string,
  to: string
): Promise<OrderRow[]> =>
  axios
    .get("/api/insights/orders", { params: { from, to } })
    .then(getData)
    .then(tPromise.decode(orderRowsT));

export const getInsightsAccounts = async (
  dimension: AccountDimension,
  from: string,
  to: string
): Promise<EntityAccount[]> =>
  axios
    .get("/api/insights/accounts", { params: { dimension, from, to } })
    .then(getData)
    .then(tPromise.decode(entityAccountsT));

export const getInsightsMonthly = async (
  firstMonth: string,
  lastMonth: string
): Promise<MonthlyTotal[]> =>
  axios
    .get("/api/insights/monthly", { params: { firstMonth, lastMonth } })
    .then(getData)
    .then(tPromise.decode(monthlyTotalsT));

export const getInsightsCo2 = async (
  from: string,
  to: string,
  firstMonth: string,
  lastMonth: string
): Promise<{ monthly: Co2Month[]; byVehicle: NamedValue[] }> =>
  axios
    .get("/api/insights/co2", { params: { from, to, firstMonth, lastMonth } })
    .then(getData)
    .then(tPromise.decode(co2ResponseT));

export const getInsightsGeography = async (
  from: string,
  to: string
): Promise<{ byCountry: GeoRow[]; byCity: GeoRow[] }> =>
  axios
    .get("/api/insights/geography", { params: { from, to } })
    .then(getData)
    .then(tPromise.decode(geographyResponseT));

export const getInsightsInvoicing = async (
  from: string,
  to: string
): Promise<InvoicingStats> =>
  axios
    .get("/api/insights/invoicing", { params: { from, to } })
    .then(getData)
    .then(tPromise.decode(invoicingStatsT));

export const getInsightsProductMix = async (
  from: string,
  to: string
): Promise<ProductMixRow[]> =>
  axios
    .get("/api/insights/product-mix", { params: { from, to } })
    .then(getData)
    .then(tPromise.decode(productMixRowsT));

export const getInsightsUtilization = async (
  from: string,
  to: string
): Promise<UtilizationRow[]> =>
  axios
    .get("/api/insights/utilization", { params: { from, to } })
    .then(getData)
    .then(tPromise.decode(utilizationRowsT));
